if (!customElements.get('product-personalization')) {
  class ProductPersonalization extends HTMLElement {
    constructor() {
      super();

      this.handleInputRef = this.handleInput.bind(this);
    }

    handleInput(event) {
      this.field.value = this.field.value.toUpperCase();

      if (this.classList.contains('single-personalization')) {
        this.validateSinglePersonalization();
      } else {
        this.validateMultiPersonalization();
      }

      if (this.lengthElement) {
        this.lengthElement.innerText = Number(event.target.maxLength) - event.target.value.length;
      }
    }

    changeEvent(valid, error, message) {
      document.dispatchEvent(new CustomEvent('alexa:personalization-change',
        { detail: { valid: valid, error: error, message: message } }
      ));
    }

    validateSinglePersonalization() {
      let fieldValue = this.field.value
      let onlyLettersAndSpace  = /^[a-zA-Z\s]+$/.test(fieldValue);
      let onlySpace = /^[\s]+$/
      let inputs = [];
      let hasManySpaces = false;
      let spaceCount = 0;
      let error = false;

      if (this.field.value != '') {
        if (!onlyLettersAndSpace) {
          this.changeEvent(false, `Only letters and one space are allowed!`, fieldValue);
          error = true;
        }
      };

      var textArray = fieldValue.split('');
      var buildText = [];
      var spacePosition = 0;

      textArray.forEach((leter, i) => {
        if (leter === ' ') {
          spaceCount++
        } else {
          buildText.push(leter);
        }
      });

      for (var i = 0; i < textArray.length; i++) {
        if (textArray[i] === ' ') {
          spacePosition = i
          break
        };
      };

      var newValue = buildText.join('');

      if (spaceCount > 1) {
        this.field.value = this.insertInPosition(newValue, ' ', spacePosition);

        this.changeEvent(false, `Only one space is allowed!`, fieldValue);
        error = true;
      };

      if (error === false) {
        this.changeEvent(this.field.checkValidity(), '', fieldValue);
      }
    }

    validateMultiPersonalization() {
      let fieldValue = this.field.value;
      let isOnlyLetters = /^[a-zA-Z\s]+$/.test(fieldValue);
      let isOnlyNumbers = /^[0-9]+$/.test(fieldValue);
      let isSpecial = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g.test(fieldValue);
      let hasEmoji  = /\p{Extended_Pictographic}/u.test(fieldValue);
      const qty = this.field.dataset.qty.split(',');
      const text_array = this.field.value.split('');
      let inputs = [];
      let error = false;

      text_array.forEach(input => {
        const inputItem = input + '|' + text_array.filter((v) => (v === input)).length;
        inputs.push(inputItem)
      });

      const uniqueInputs = inputs.filter((value, index, array) => array.indexOf(value) === index);

      qty.forEach(qtyItem => {
        const qtyName = qtyItem.split('|')[0];
        const qtyInventory = parseInt(qtyItem.split('|')[1]);

        uniqueInputs.forEach(uniqueInput => {
          const inputOptions = uniqueInput.split(',');

          inputOptions.forEach(option => {
            const optionName = option.split('|')[0];
            const optionQty = parseInt(option.split('|')[1]);

            if (optionName === qtyName) {
              if (optionQty > qtyInventory) {
                this.field.value = this.field.value.replace(qtyName, '');

                if (qtyInventory <= 0 ) {
                  this.changeEvent(false, `The variant ${qtyName} is out of stock!`, fieldValue);
                  error = true;
                } else {
                  this.changeEvent(false, `There is only ${qtyInventory} available from ${qtyName} variant`, fieldValue);
                  error = true;
                }
              };
            };
          });
        });
      })

      if (this.isInexpensive) {
        const regexpUnicodeModified = /\p{RI}\p{RI}|\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?(\u{200D}\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?)+|\p{EPres}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?|\p{Emoji}(\p{EMod}+|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})/gu
        const specialCharactersArray = fieldValue.match(regexpUnicodeModified)

        this.field.dataset.special = specialCharactersArray;
        const variantsArray = this.field.dataset.letters.split(',')
        let namesArray = [];

        variantsArray.forEach(variantItem => {
          const letterItemName = variantItem.split('|')[0];
          namesArray.push(letterItemName)
        });

        this.field.dataset.names = namesArray;
        let alowedCharacters = this.field.dataset.alowed.split(',');
        let fieldValueArray = fieldValue.split('');

        fieldValueArray.forEach(letter => {
          if (alowedCharacters.indexOf(letter) === -1) {
            if (!this.containsNonLatinCodepoints(letter)) {
              this.changeEvent(false, `The character ${letter} is not allowed!`, fieldValue);
              error = true;
            };
          };
        });

        if (specialCharactersArray != null) {
          specialCharactersArray.forEach(char => {
            if (namesArray.indexOf(char) === -1) {
              this.changeEvent(false, `The character ${char} is not allowed!`, fieldValue);
              error = true;
            };
          });
        }
      };

      if (this.field.value != '') {
        if (!this.isInexpensive) {
          if (!isOnlyLetters) {
            this.changeEvent(false, `Only letters are allowed!`, fieldValue);
            error = true;
          }
        };
      };

      let unavailableArray = this.field.dataset.unavailable.split(',');
      let uArr = [];

      unavailableArray.forEach(unavailableLetter  => {
        if (this.field.value.includes(unavailableLetter)) {
          if (this.field.value != '') {
            if (unavailableLetter != '') {
              uArr.push(unavailableLetter)
            };
          };
        };
      });

      if (uArr.length > 0) {
        let unavailableLettersString = uArr.join('');
        let newValue = this.field.value.replace(unavailableLettersString, '');
        this.field.value = newValue;

        if (uArr.length > 1) {
          this.changeEvent(false, `The letters: ( ${uArr} ) are out of stock!`, fieldValue);
          error = true;
        } else {
          this.changeEvent(false, `The letter: "${uArr}" is out of stock!`, fieldValue);
          error = true;
        }
      };

      if (error === false) {
        this.changeEvent(this.field.checkValidity(), '', fieldValue);
      }
    }

    containsNonLatinCodepoints(text) {
      return /[^\u0000-\u00ff]/.test(text);
    }

    insertInPosition(string, substring, position) {
      let output = [string.slice(0, position), substring, string.slice(position)].join('');
      return output
    }

    insertEmoji(event) {
      this.field.value += event.target.textContent;
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.handleInputRef);
    }

    connectedCallback() {
      this.lengthElement = this.querySelector('.js-length');
      this.field = this.querySelector('.js-personalization-field');
      this.emojies = this.querySelectorAll('.js-insert-emoji');
      this.isInexpensive = false;

      if (this.classList.contains('inexpensive')) {
        this.isInexpensive = true;
      };

      this.emojies.forEach(emoji => {
        emoji.addEventListener('click', this.insertEmoji.bind(this));
      })

      this.addEventListener('input', this.handleInputRef);

      document.dispatchEvent(new CustomEvent('alexa:personalization-enabled'));
    }
  }

  customElements.define('product-personalization', ProductPersonalization);
}
